import request from "@/utils/request";
import ENDPOINT from "@/config/endpoint";

function list(params) {
  return request({
    url: ENDPOINT.FILES,
    method: "get",
    params,
  });
}

function show(fileId) {
  return request({
    url: `${ENDPOINT.FILES}/${fileId}`,
    method: "get",
  });
}

function create(data) {
  return request({
    url: ENDPOINT.FILES,
    method: "post",
    data,
  });
}

function update(data) {
  return request({
    url: `${ENDPOINT.FILES}/${data.id}`,
    method: "patch",
    data,
  });
}

async function updateMultiple(data) {
  return await request({
    url: `${ENDPOINT.FILES}`,
    method: "patch",
    data,
  });
}

function remove(data) {
  return request({
    url: `${ENDPOINT.FILES}/${data.id}`,
    method: "delete",
    data,
  });
}

export default {
  list,
  create,
  update,
  updateMultiple,
  remove,
  show
};
